import {applyPhoneMask} from "/assets/js/utils/phone-mask";
import {notice} from "/assets/js/utils/notices";

class AuthModal {
    constructor() {
        this.modal = document.getElementById('auth');

        // Все три вида и кнопки переключения между ними
        this.views = this.modal.querySelectorAll('[data-auth-view]');
        this.switchButtons = this.modal.querySelectorAll('[data-auth-switch]');

        // Вид: вход
        this.loginView = this.modal.querySelector('[data-auth-view="login"]');
        this.loginEmailInput = this.loginView.querySelector('input[name="email"]');
        this.loginPasswordInput = this.loginView.querySelector('input[name="password"]');
        this.loginButton = this.loginView.querySelector('.auth-modal__content-wrap-step-button-login');
        this.loginNonce = this.loginView.querySelector('#ns-login-nonce');

        // Блок "раньше входили по телефону" (внутри вида "вход")
        this.legacyToggle = this.loginView.querySelector('[data-legacy-toggle]');
        this.legacyPhoneField = this.loginView.querySelector('[data-legacy-phone-field]');
        this.legacyPhoneInput = this.legacyPhoneField?.querySelector('input[type="tel"]');

        // Вид: регистрация
        this.registerView = this.modal.querySelector('[data-auth-view="register"]');
        this.registerNameInput = this.registerView.querySelector('input[name="name"]');
        this.registerCompanyInput = this.registerView.querySelector('input[name="company"]');
        this.registerPhoneInput = this.registerView.querySelector('input[name="phone"]');
        this.registerEmailInput = this.registerView.querySelector('input[name="email"]');
        this.registerPasswordInput = this.registerView.querySelector('input[name="password"]');
        this.registerButton = this.registerView.querySelector('.auth-modal__content-wrap-step-button-register');
        this.registerNonce = this.registerView.querySelector('#ns-register-nonce');
        this.registerCheckboxes = this.registerView.querySelectorAll('.auth-modal__content-wrap-step-checkbox-policy .checkbox__input.required');

        // Вид: восстановление пароля
        this.lostPasswordView = this.modal.querySelector('[data-auth-view="lost-password"]');
        this.lostPasswordEmailInput = this.lostPasswordView.querySelector('input[name="email"]');
        this.lostPasswordButton = this.lostPasswordView.querySelector('.auth-modal__content-wrap-step-button-lost-password');
        this.lostPasswordNonce = this.lostPasswordView.querySelector('#ns-lost-password-nonce');

        this.closeButton = this.modal.querySelector('.auth-modal__content-close-button');
        this.modalContent = this.modal.querySelector('.auth-modal__content');
        this.modalContentWrap = this.modal.querySelector('.auth-modal__content-wrap');
        this.header = document.querySelector('.header');
        this.headerLoginBtn = document.querySelector('#header_login');

        this.init();
    }

    init() {
        if (this.registerPhoneInput) {
            this.registerPhoneInput.addEventListener('input', applyPhoneMask);
        }
        if (this.legacyPhoneInput) {
            this.legacyPhoneInput.addEventListener('input', applyPhoneMask);
        }

        this.initViewSwitching();

        if (this.legacyToggle) {
            this.initLegacyToggle();
        }

        if (this.loginButton) {
            this.loginButton.addEventListener('click', () => this.login());
        }

        if (this.registerButton) {
            this.registerButton.addEventListener('click', () => this.register());
        }

        if (this.lostPasswordButton) {
            this.lostPasswordButton.addEventListener('click', () => this.lostPassword());
        }

        if (this.modal) {
            this.initModalClose();
            this.initModalPosition();
        }

        this.initCheckboxes(this.registerCheckboxes);
    }

    initViewSwitching() {
        this.switchButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.switchView(button.dataset.authSwitch);
            });
        });
    }

    switchView(target) {
        this.views.forEach(view => {
            view.hidden = view.dataset.authView !== target;
        });
    }

    initLegacyToggle() {
        this.legacyToggle.addEventListener('click', () => {
            const isHidden = this.legacyPhoneField.hasAttribute('hidden');
            if (isHidden) {
                this.legacyPhoneField.removeAttribute('hidden');
            } else {
                this.legacyPhoneField.setAttribute('hidden', '');
                if (this.legacyPhoneInput) {
                    this.legacyPhoneInput.value = '';
                }
            }
        });
    }

    initCheckboxes(checkboxes) {
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', () => {
                const label = checkbox.closest('.auth-modal__content-wrap-step-checkbox-policy');
                if (label && checkbox.checked) {
                    label.classList.remove('is-error');
                }
            });
        });
    }

    validateCheckboxes(checkboxes) {
        const uncheckedCheckboxes = Array.from(checkboxes).filter(checkbox => !checkbox.checked);

        if (uncheckedCheckboxes.length > 0) {
            notice('Необходимо согласиться со всеми условиями', 'error');
            uncheckedCheckboxes.forEach(checkbox => {
                const label = checkbox.closest('.auth-modal__content-wrap-step-checkbox-policy');
                if (label) {
                    label.classList.add('is-error');
                }
            });
            return false;
        }

        checkboxes.forEach(checkbox => {
            const label = checkbox.closest('.auth-modal__content-wrap-step-checkbox-policy');
            if (label) {
                label.classList.remove('is-error');
            }
        });

        return true;
    }

    setInputSuccess(inputElement) {
        if (!inputElement) return;
        const label = inputElement.closest('.input');
        if (label) {
            label.classList.remove('is-error');
            label.classList.add('is-success');
        }
    }

    setInputError(inputElement) {
        if (!inputElement) return;
        const label = inputElement.closest('.input');
        if (label) {
            label.classList.remove('is-success');
            label.classList.add('is-error');
        }
    }

    clearInputState(inputElement) {
        if (!inputElement) return;
        const label = inputElement.closest('.input');
        if (label) {
            label.classList.remove('is-success', 'is-error');
        }
    }

    setFormLoading(button, inputs, isLoading) {
        if (button) {
            button.classList.toggle('is-loading', isLoading);
            button.disabled = isLoading;
        }
        inputs.forEach(input => {
            if (!input) return;
            input.disabled = isLoading;
        });
    }

    async login() {
        const email = this.loginEmailInput?.value.trim() || '';
        const password = this.loginPasswordInput?.value || '';
        const legacyPhone = (!this.legacyPhoneField?.hasAttribute('hidden') && this.legacyPhoneInput)
            ? this.legacyPhoneInput.value
            : '';

        if (!email) {
            notice('Введите email', 'error');
            this.setInputError(this.loginEmailInput);
            return;
        }

        if (!password) {
            notice('Введите пароль', 'error');
            this.setInputError(this.loginPasswordInput);
            return;
        }

        const inputs = [this.loginEmailInput, this.loginPasswordInput, this.legacyPhoneInput];
        this.setFormLoading(this.loginButton, inputs, true);

        let url = document.location.origin + '/?wc-ajax=ns_login';

        try {
            const formData = new FormData();
            formData.append('email', email);
            formData.append('password', password);
            formData.append('phone', legacyPhone);
            formData.append('ns-login-nonce', this.loginNonce.value);

            const response = await fetch(url, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.success) {
                this.setInputSuccess(this.loginEmailInput);
                this.setInputSuccess(this.loginPasswordInput);

                this.headerLoginBtn.removeAttribute('data-modal');
                this.headerLoginBtn.setAttribute('data-user-role', data.data.current_user_role);

                window.location.replace(window.location.pathname);
            } else {
                this.setInputError(this.loginEmailInput);
                this.setInputError(this.loginPasswordInput);

                const errorMessage = data.message || 'Неверный email или пароль';
                notice(errorMessage, 'error');
            }
        } catch (error) {
            this.setInputError(this.loginEmailInput);
            this.setInputError(this.loginPasswordInput);
            console.log(error);
            notice('Произошла ошибка при входе', 'error');
        } finally {
            this.setFormLoading(this.loginButton, inputs, false);
        }
    }

    async register() {
        const name = this.registerNameInput?.value.trim() || '';
        const company = this.registerCompanyInput?.value.trim() || '';
        const phone = this.registerPhoneInput?.value || '';
        const email = this.registerEmailInput?.value.trim() || '';
        const password = this.registerPasswordInput?.value || '';

        if (!name) {
            notice('Введите имя и фамилию', 'error');
            this.setInputError(this.registerNameInput);
            return;
        }

        if (!phone) {
            notice('Введите номер телефона', 'error');
            this.setInputError(this.registerPhoneInput);
            return;
        }

        if (!email) {
            notice('Введите email', 'error');
            this.setInputError(this.registerEmailInput);
            return;
        }

        if (!password || password.length < 8) {
            notice('Пароль должен содержать не менее 8 символов', 'error');
            this.setInputError(this.registerPasswordInput);
            return;
        }

        if (!this.validateCheckboxes(this.registerCheckboxes)) {
            return;
        }

        const inputs = [
            this.registerNameInput,
            this.registerCompanyInput,
            this.registerPhoneInput,
            this.registerEmailInput,
            this.registerPasswordInput,
        ];
        this.setFormLoading(this.registerButton, inputs, true);

        let url = document.location.origin + '/?wc-ajax=ns_register';

        try {
            const formData = new FormData();
            formData.append('name', name);
            formData.append('company', company);
            formData.append('phone', phone);
            formData.append('email', email);
            formData.append('password', password);
            formData.append('ns-register-nonce', this.registerNonce.value);

            const response = await fetch(url, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.success) {
                inputs.forEach(input => this.setInputSuccess(input));

                this.headerLoginBtn.removeAttribute('data-modal');
                this.headerLoginBtn.setAttribute('data-user-role', data.data.current_user_role);

                window.location.replace(window.location.pathname);
            } else {
                const errorMessage = data.message || 'Не удалось зарегистрироваться';
                notice(errorMessage, 'error');
            }
        } catch (error) {
            console.log(error);
            notice('Произошла ошибка при регистрации', 'error');
        } finally {
            this.setFormLoading(this.registerButton, inputs, false);
        }
    }

    async lostPassword() {
        const email = this.lostPasswordEmailInput?.value.trim() || '';

        if (!email) {
            notice('Введите email', 'error');
            this.setInputError(this.lostPasswordEmailInput);
            return;
        }

        const inputs = [this.lostPasswordEmailInput];
        this.setFormLoading(this.lostPasswordButton, inputs, true);

        let url = document.location.origin + '/?wc-ajax=ns_lost_password';

        try {
            const formData = new FormData();
            formData.append('email', email);
            formData.append('ns-lost-password-nonce', this.lostPasswordNonce.value);

            const response = await fetch(url, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.success) {
                this.setInputSuccess(this.lostPasswordEmailInput);
                notice(data.data.message || 'Если такой email зарегистрирован, мы отправили новый пароль на почту', 'success');
                this.lostPasswordEmailInput.value = '';
                this.switchView('login');
            } else {
                this.setInputError(this.lostPasswordEmailInput);
                const errorMessage = data.message || 'Не удалось отправить новый пароль';
                notice(errorMessage, 'error');
            }
        } catch (error) {
            this.setInputError(this.lostPasswordEmailInput);
            console.log(error);
            notice('Произошла ошибка при восстановлении пароля', 'error');
        } finally {
            this.setFormLoading(this.lostPasswordButton, inputs, false);
        }
    }

    initModalClose() {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const isOpen = this.modal.classList.contains('is-open');
                    if (!isOpen) {
                        this.resetModal();
                    }
                }
            });
        });

        if (this.modal) {
            observer.observe(this.modal, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
    }

    initModalPosition() {
        this.constructor.initModalPositionStatic({
            modal: this.modal,
            header: this.header,
            updateModalPosition: () => this.updateModalPosition(),
            headerClass: 'header--auth-open'
        });
    }

    static initModalPositionStatic({ modal, header, updateModalPosition, headerClass = 'header--auth-open' }) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const isOpen = modal.classList.contains('is-open');
                    if (isOpen) {
                        if (header) {
                            header.classList.remove('header--scrolling');
                            header.classList.add(headerClass);
                        }
                        document.body.style.overflow = 'hidden';
                        if (updateModalPosition) {
                            updateModalPosition();
                        }
                    } else {
                        document.body.style.overflow = '';
                        if (header) {
                            header.classList.remove(headerClass);
                        }
                    }
                }
            });
        });

        if (modal) {
            observer.observe(modal, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
    }

    updateModalPosition() {
        if (!this.modalContent || !this.header) return;

        const headerHeight = this.header.offsetHeight;

        if (this.modalContentWrap) {
            const windowHeight = window.innerHeight;
            const maxHeight = windowHeight - headerHeight;
            this.modalContentWrap.style.maxHeight = `${maxHeight}px`;
        }
    }

    resetModal() {
        // Сброс вида входа
        [this.loginEmailInput, this.loginPasswordInput, this.legacyPhoneInput].forEach(input => {
            if (!input) return;
            input.value = '';
            this.clearInputState(input);
        });

        if (this.legacyPhoneField) {
            this.legacyPhoneField.setAttribute('hidden', '');
        }

        // Сброс вида регистрации
        [
            this.registerNameInput,
            this.registerCompanyInput,
            this.registerPhoneInput,
            this.registerEmailInput,
            this.registerPasswordInput,
        ].forEach(input => {
            if (!input) return;
            input.value = '';
            this.clearInputState(input);
        });

        // Сброс вида восстановления пароля
        if (this.lostPasswordEmailInput) {
            this.lostPasswordEmailInput.value = '';
            this.clearInputState(this.lostPasswordEmailInput);
        }

        // Возврат на вид "Вход"
        this.switchView('login');

        [...this.registerCheckboxes].forEach(checkbox => {
            checkbox.checked = false;
            const label = checkbox.closest('.auth-modal__content-wrap-step-checkbox-policy');
            if (label) {
                label.classList.remove('is-error');
            }
        });

        this.setFormLoading(this.loginButton, [], false);
        this.setFormLoading(this.registerButton, [], false);
        this.setFormLoading(this.lostPasswordButton, [], false);
    }
}

document.addEventListener('DOMContentLoaded', function() {
    new AuthModal();
});

export { AuthModal };
